import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { Dto } from '../../../data';
import { IUserAdminService } from './../';
let template = require('./users.html');

class UsersComponent extends ComponentRegistration {

    constructor() {
        super('users', {
            controller: UsersController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
            }
        });
    }
}

interface IUsersController {

}

class UsersController implements IUsersController {
    private static $inject: Array<string> = ['UserAdmin', '$mdDialog'];
    private profile: Dto.IProfile;
    private savedProfile: Dto.IProfile;
    private edit: boolean;
    private add: boolean;
    private clear: boolean;

    constructor(private UserAdmin: IUserAdminService) {
       console.log('UsersController loaded');
    }

    private userSelected(profile: Dto.IProfile) {
        this.profile = profile;
    }

    private inEditMode(edit: boolean) {
        this.edit = edit;
    }

    private addUser() {
        this.profile = {
            firstName: "",
            lastName: "",
            language: "en",
            email: "",
            isEnabled: true
        } as Dto.IProfile;
        this.add = true;

    }

    private onFormCancel(action: string) {
        if (action === "add") {
            this.userSelected(null);
            this.add = false;
        }
    }

    private onFormSave(user: Dto.IProfile) {
        this.savedProfile = user;
        this.add = false;
    }

    private userLoadCancelled(user: Dto.IProfile) {
        this.userSelected(user);
    }
}

let usersComponent = new UsersComponent();
export default usersComponent;
export { usersComponent as UsersComponent, IUsersController, UsersController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/users/users.ts